export default __webpack_public_path__ + "static/media/app2-15.7b1b0c02.jpg";